import './component.scss'
import '@splidejs/splide/css';
import { Splide } from '@splidejs/splide';

const PC_PER_PAGE = 3;

const SLIDER_CONFIGS = {
  'top-review-pc': {
    speed: 800,
    perPage: PC_PER_PAGE,
    perMove: PC_PER_PAGE,
    gap: '8px',
    pagination: false,
  },
  'top-review-sp': {
    speed: 800,
    perMove: 1,
    gap: '12px',
    padding: '30px',
    pagination: false,
    focus: 'center',
  }
};

// スライダー初期化関数
function initializeSlider (id, config) {
  const element = document.getElementById(id);
  if (!element) return null;

  const splide = new Splide(`#${id}`, config);
  splide.mount();
}

// コメント展開機能
function initializeCommentToggle() {
  const moreButtons = document.querySelectorAll('.js-top-review-card__more-button');

  moreButtons.forEach(button => {
    const comment = button.closest('.top-review-card__comment-container').querySelector('.js-top-review-card__comment');

    // 3行以下の場合は「もっと見る」ボタンを非表示にする
    const commentHeight = comment.scrollHeight;
    const displayHeight = comment.offsetHeight;

    if (commentHeight <= displayHeight) {
      button.classList.add('hidden');
      return;
    }

    // ボタンをクリックした時はカードのリンク先に遷移する
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      window.location.href = button.closest('.top-review-card').href;
    });
  });
}

window.addEventListener('load', function () {
  Object.entries(SLIDER_CONFIGS).forEach(([id, config]) => { initializeSlider(id, config); });

  // コメント展開機能を初期化
  initializeCommentToggle();

  const cards = document.querySelectorAll('.js-top-review-card');

  // まず全 review をリセット（リフロー用）
  cards.forEach(card => {
    const review = card.querySelector('.js-top-review-card__comment');
    if (review) {
      review.style.height = 'auto';
      review.style.webkitLineClamp = null;
    }
  });
});
